import React from "react";
interface CardData{
    param:any,
    realData:any,
    setItems:any,
    setActiveKey:any,
    items:any,
    viewTypeList:any,
    setViewTypeList:any;
    viewOperate:any;
}
const NullPreview: React.FC<CardData> = (cardData) => {
    return (
        <>
            <div style={{height:'490px'}}>无卡片，请添加卡片!</div>
        </>
    )
}
export default NullPreview;